import styled from '@emotion/styled';
import { PCCECertificate } from '../comm/about-range/Certificate';
import { PCCECriterion } from '../comm/about-range/Criterion';
import { PCCERange } from '../comm/about-range/Range';
import { PCCERegistration } from '../comm/about-range/Registration';

const Container = styled.div`
  display: grid;
  row-gap: 70px;
`;

const AboutRange = () => (
  <Container>
    <PCCERange />
    <PCCECriterion />
    <PCCECertificate />
    <PCCERegistration />
  </Container>
);

export default AboutRange;
